import React, { useEffect } from 'react';
import SkeletonImage from '../Utils/Skeleton/skeleton-image-component';
import Tooltip from '../Utils/Tooltip/tooltip-component';

const CourseModal = ({ id, course, trigger, totalCourses = 3 }) => {


    useEffect(() => {
    }, []);


    const handleTrigger = async (e) => {
        e.preventDefault();
        return trigger([id, course.title]);
    }

    const CourseIndicator = ({ totalCourses, currentCourseId }) => {
        return (
            <div className="flex flex-col">
                {Array.from({ length: totalCourses }, (_, index) => (
                    <span key={index} className={`my-2 mr-5 h-2 w-2 rounded-full  ${index === currentCourseId ? 'bg-blue-500' : 'bg-gray-300'}`}></span>
                ))}
            </div>
        );
    };

    return (
        <div onClick={handleTrigger} className="modal-style w-full rounded-2xl max-h-[700px] bg-white dark:bg-gray-900 transition-all py-10 lg:py-20 ease-in-out duration-300 shadow-md hover:shadow-xl hover:cursor-pointer" >
            <Tooltip text="Click me">

                {/* Course Content */}
                <div className='flex flex-col lg:flex-row justify-center align-middle text-center lg:text-right lg:p-5 h-auto w-full'>
                    {/* Media */}
                    <div className='flex lg:w-3/5 w-4/5 items-center align-middle hover:scale-105 transition-all ml-5 mr-3 lg:m-4 lg:p-5 ease-in-out duration-300 '>

                        {/* Course Indicator */}
                        <CourseIndicator totalCourses={totalCourses} currentCourseId={id} />

                        {course?.image && !course.video ? (
                            <img src={course?.image} alt="" className="flex align-top justify-start  rounded-4xl aspect-[1] h-auto max-w-full" />
                        ) : (
                            <video key={course?.video} autoPlay loop muted playsInline className='flex rounded-3xl'>
                                <source src={course?.video} type="video/mp4" className="flex align-top p-5 justify-start aspect-[1] h-auto max-w-full" />
                            </video>
                        )}

                        {!course?.image && !course?.video && <SkeletonImage />}
                    </div>

                    {/* Course Details */}
                    <div className="flex flex-col justify-center w-full rounded-xl mt-4 lg:mx-10">
                        <h5 className="mb-2 text-lg lg:text-4xl font-bold text-gray-700 dark:text-white">{course?.title}</h5>

                        {/* Additional Information */}
                        <h3 className="text-md lg:text-xl font-bold mb-1">{course?.subtitle}</h3>
                    </div>
                </div>
            </Tooltip>
        </div>
    );
};

export default CourseModal;
